// import React, { useCallback, useMemo, useState} from "react";
// import ReactDOM from 'react-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { useTranslation } from "react-i18next";
// import { pdfjs, Document, Page, Outline } from 'react-pdf';
// import { Card, CardBody, CardHeader, Container, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
// import { Stage, Layer, Rect, Text, Group, Circle, Shape } from 'react-konva';
import Konva from 'konva';
import produce from 'immer';
import { Stage, Layer, Rect, Text, Group, Circle, Shape } from 'react-konva';
// import clsx from "clsx";

// import { useModals, CLOSE_PREVIEW } from "../../context/modals";

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Document, Page, pdfjs, PDFPageItem } from 'react-pdf';
import  {
    Button, 
    ButtonGroup, 
    Spinner,
} from 'reactstrap';
import TratoLoader from '../TratoLoader'
import { noop } from '../../utils'
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import clsx from 'clsx';

// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const Controls = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${props => props.height ? '100px' : '60px'};
`
const ClickPanel = styled.div`
  position: absolute;
  cursor: pointer;
  width: 50%;
  z-index: 1000;
  height: 100%;
  right: ${props => props.right};
  left: ${props => props.left};
  top: ${props => props.top};
  bottom: ${props => props.bottom};
`
const options = {
  cMapUrl: `cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: 'standard_fonts/',
};


export function PdfPreviewContainer({ document: doc, isPdf, isEditable, currentPage, participants, signatures, card, width: initialWidth, header = true, onAddSignature, onRemoveSignature, onUpdateSignature }) {
    const { t } = useTranslation('common');
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [rotate, setRotate] = useState(0);
    console.log({doc, participants, signatures})

    const handleNextPage = () => {
      // setCurrentPage(Math.min(currentPage + 1, totalPages))
    }

    const handlePrevPage = () => {
        // setCurrentPage(Math.max(currentPage - 1, 1))
    }

    useEffect(() => {
      setWidth(0)
  }, [currentPage])
    const handleDragStart = useCallback((e) => {
        e.target.setAttrs({
          shadowOffset: {
            x: 15,
            y: 15
          },
          scaleX: 1,
          scaleY: 1
        });
      }, []);
     
      const handleDragEnd = e => {
        const signature = {
          _id: e.target.attrs.id,
          left: e.target.attrs.x,
          top: e.target.attrs.y,
         width: 200,
        height: 100,
          page: currentPage
        }
  
        onUpdateSignature(e.target.attrs.participantId, signature)
  
        e.target.to({
          duration: 0.5,
          easing: Konva.Easings.ElasticEaseOut,
          scaleX: 1,
          scaleY: 1,
          shadowOffsetX: 5,
          shadowOffsetY: 5
        });
      };
  
      const handleDragBound = (pos, event) => {
        const height = 842;
        const width = 595;
       
        const newY = pos.y < 15 ? 15 : (pos.y > height-104) ? height-104 : pos.y;
        const newX = pos.x < 1 ? 1 : (pos.x > width-205) ? width-205: pos.x;
        
        return {
          x: newX,
          y: newY
        };
      }
  
      const addSignature = (participant) => () => {
        onAddSignature(participant._id)
      }
      const handleRemoveSignature = (participant, signature) => {
        onRemoveSignature(participant._id, signature._id)
    }
    

    const handleUpdateSignature = (participantId, signature) => {
        onUpdateSignature(participantId, signature)
    }

      const handleDocumentLoad = ({ numPages }) => {
        setTotalPages(numPages)
    }
    const handlePageLoad = ({  width, height, ...page }) => {
      setHeight(height)
      setWidth(width)

  }

      return (

        <PdfPreview
                width={width}
                url={doc.importedPdf}
                pageNumber={currentPage}
                resetWidthOnUrlChange
                // onPageChange={setCurrentPage}
                onDocumentLoad={handleDocumentLoad}
                onPageLoad={handlePageLoad}
                // clickPanels  
            >    
                    <PDFSignaturesContainer
                        resetWidthOnUrlChange
                        document={doc}
                        signatures={signatures}
                        participants={participants}
                        width={width} 
                        height={height}
                        rotate={rotate}
                        clickPanels
                        currentPage={currentPage}
                        onNextPage={handleNextPage}
                        onPrevPage={handlePrevPage}
                        isEditable={isEditable}
                        onRemoveSignature={handleRemoveSignature}
                        onUpdateSignature={handleUpdateSignature}
                    />
            </PdfPreview>
      )
}



export function PDFSignaturesContainer({ document: doc, participants: initialParticipants = [], signatures, width, height, rotate = 0, currentPage, isEditable, showSignatureConfirmations, participantId, signatureConfirmations = {}, ratio = 1, onUpdateSignature, onRemoveSignature, onConfirmSignature, onNextPage, onPrevPage }) {
   
  const [participants, setParticipants] = useState(initialParticipants);

  useEffect(() => {
      setParticipants(initialParticipants ?? [])
  }, [initialParticipants])

  const handleDragStart = useCallback((e) => {
      e.target.setAttrs({
        shadowOffset: {
          x: 15,
          y: 15
        },
        scaleX: 1,
        scaleY: 1
      });
    }, []);
   
    const handleDragEnd = e => {
      const participantId = e.target.attrs.participantId;
      const signature = {
        _id: e.target.attrs.id,
        left: e.target.attrs.x,
        top: e.target.attrs.y,
        width: 200,
        height: 100,
        page: currentPage
      }

      setParticipants(produce(draft => {
          const participantIdx = draft?.findIndex(p => p._id === participantId) || -1;

          if (participantIdx < 0) return;

          const participant = draft[participantIdx];

          if (!participant.signatures) participant.signatures = [];
          
          const signatureIdx = participant.signatures?.findIndex(s => s._id === signature._id) || -1;

          if (signatureIdx < 0) return;

          participant.signatures[signatureIdx] = signature;

      }))

      onUpdateSignature(participantId, signature)

      e.target.to({
        duration: 0.5,
        easing: Konva.Easings.ElasticEaseOut,
        scaleX: 1,
        scaleY: 1,
        shadowOffsetX: 5,
        shadowOffsetY: 5
      });
    };

    const handleDragBound = (signature, pos, event) => {
      const newY = pos.y < 2 ? 2 : (pos.y > height - signature.height) ? height - signature.height: pos.y;
      const newX = pos.x < 2 ? 2 : (pos.x > width - signature.width) ? width - signature.width: pos.x;

      console.log({newY,newX, signature, pos})
      
      return {
        x: newX,
        y: newY
      };
    }

  
  return (
      <div style={{position: 'absolute', top: 0, left:0, width, height, zIndex: 1000}}>
          <Stage width={width} height={height} className="layer" id='layer'>
          <Layer>           
              <Rect
                  width={width/2}
                  height={height}
                  // fill="black"
                  // opacity={0.3}
                  shadowEnabled={false}
                  onClick={onPrevPage}
              />       
              <Rect
                  width={width/2}
                  height={height}
                  x={width/2}
                  shadowEnabled={false}
                  onClick={onNextPage}
              />       
              {
                  participants.map((participant) => {
                      const participantSignatures = signatures[participant._id];
                      if (!participantSignatures) return null;

                      return participantSignatures.map((signature, i) => { 
                          
                          if (signature.page !== currentPage) return null;

                          return (
                                  <SignatureElement 
                                      key={signature._id}
                                      participant={participant} 
                                      signature={signature} 
                                      hideRemove={!isEditable}
                                      ratio={ratio}
                                      signatureType={doc.signatureType}
                                      showSignatureConfirmations={showSignatureConfirmations && participant._id === participantId}
                                      isConfirmed={signatureConfirmations[signature._id]}
                                      onRemove={onRemoveSignature}
                                      onConfirmSignature={onConfirmSignature}
                                      draggable={isEditable} 
                                      onDragStart={handleDragStart}
                                      onDragEnd={handleDragEnd}
                                      onDragBound={handleDragBound}
                              />
                          )
                      })
                  })
              }
              </Layer>
          </Stage>
      </div>
  );
}

const SIGNATURE_DEFAULT_WIDTH = 200;
const SIGNATURE_DEFAULT_HEIGHT = 100;

function SignatureElement({ participant, signature, hideRemove, draggable, showSignatureConfirmations, isConfirmed, signatureType, ratio = 1, onDragStart, onDragEnd, onDragBound, onRemove, onConfirmSignature }) {
  const { width = SIGNATURE_DEFAULT_WIDTH, height = SIGNATURE_DEFAULT_HEIGHT, customSize } = signature;
  const realWidth = customSize ? width*ratio : SIGNATURE_DEFAULT_WIDTH*ratio;
  const realHeight = customSize ? height*ratio : SIGNATURE_DEFAULT_HEIGHT*ratio;

  const { t } = useTranslation();

  const handleRemove = () => {
      onRemove(participant, signature)
  }
  const handleConfirmSignature = () => {
      if (showSignatureConfirmations) {
          onConfirmSignature(participant, signature)
      }
  }

  const handleDragBound = (pos, event) => {
      return onDragBound({
          ...signature,
          width,
          height
      }, pos, event);

      
  }

  return (
      <Group   
          key={signature._id}
          x={signature.left * ratio} 
          y={signature.top * ratio}
          id={signature._id}
          width={realWidth}
          height={realHeight}
          participantId={participant._id}
          draggable={draggable}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          dragBoundFunc={handleDragBound}
          onClick={handleConfirmSignature}
      >
         
          <Text 
              fontSize={18*ratio} 
              offsetY={-realHeight/2.5}
              width={realWidth}
              height={realHeight}
              text={`Área de firma \n ${participant.label}`}
              align="center"
          />
          <Rect
              width={realWidth}
              height={realHeight}
              fill="black"
              opacity={0.3}
              shadowEnabled={false}
          />
          {
              showSignatureConfirmations &&
              <Group   
                  x={5}
                  y={5}
                  onMouseDown={handleConfirmSignature}
              >
              <Shape
                  onClick={handleConfirmSignature}
                  sceneFunc={function (ctx, shape) {
                      const centerX = 0;
                      const centerY = 0;
                      ctx.beginPath()

                       //circle  
                      const radius = 9*ratio;
                      //draw circle
                      ctx.beginPath();
                      ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
                      ctx.fillStyle = isConfirmed ? 'green' : 'orange';
                      ctx.fill();
                      ctx.lineWidth = 1;
                      ctx.strokeStyle = isConfirmed ? 'green' : 'orange';
                      ctx.stroke();
                      ctx.fillStrokeShape(this);
                      
                      //draw tick
                      if (isConfirmed) {
                          ctx.beginPath();
                          ctx.moveTo(-4*ratio,-1*ratio);
                          ctx.lineTo(-1*ratio, 2*ratio);
                          ctx.lineTo(5*ratio,-4*ratio);
                          ctx.lineWidth = 2*ratio;
                          ctx.strokeStyle = '#fff';
                          ctx.stroke();    
                      }
                  }}
                  // stroke="white"
                  strokeWidth={2}
              />
              </Group>
          }
              
           {!hideRemove && <Group   
                  x={realWidth}
                  onClick={handleRemove}
              >
                  <Circle 
                      participantId={participant._id}
                     
                      signatureId={signature._id}
                      
                      fill="red"
                      radius={9}
                  />
                  <Shape
                      sceneFunc={(ctx, shape) => {
                          const x = 0;
                          const y = 0;
                          ctx.beginPath();
                          const width = 4;

                          ctx.moveTo(x - width, y - width);
                          ctx.lineTo(x + width, y + width);

                          ctx.moveTo(x + width, y - width);
                          ctx.lineTo(x - width, y + width);
                          ctx.stroke();
                          ctx.fillStrokeShape(shape)
                      }}
                      stroke="white"
                      strokeWidth={2}
                  />
              </Group>}
         
      </Group>
      
  )
}


// export function ContractPreviewPdf({ contract, participants, url, width, editable, currentPage, offset = 0, signatures, onDragStart, onDragEnd, onDragBound, onRemoveSignature }) {
//     const [numPages, setNumPages] = useState(1);
//     const [status, setStatus] = useState('');
//     const onDocumentLoadSuccess = ({ numPages }) => {
//         setNumPages(numPages)
//         setStatus('document-loaded')
//     }

//     return (
              
//             <div className="document-container d-flex flex-column align-items-center"> {/*p-2 mt-3 */}
//                 <Stage width={595} height={842} className="layer" id='layer'>
//                   <Layer >
                  
//                     {
//                       status === 'document-loaded' &&
//                       participants?.map(participant  => 
//                         signatures[participant._id]?.map((signature, i) => {

//                         if (currentPage && currentPage !== signature.page) {
//                             return null
//                         }

//                         return (
//                                 <Group   
//                                     key={i}
//                                     x={signature.left} 
//                                     y={signature.top}
//                                     id={signature._id}
//                                     width={signature.width}
//                                     height={signature.height}
//                                     participantId={participant._id}
//                                     draggable={editable}
//                                     onDragStart={onDragStart}
//                                     onDragEnd={onDragEnd}
//                                     dragBoundFunc={onDragBound}
//                                 >
//                                 <Text 
//                                     fontSize={18} 
//                                     offsetY={-100/2.5}
//                                     width={200}
//                                     height={100}
//                                     text={`Área de firma \n ${participant.label}`}
//                                     align="center"
//                                 />
//                                 <Rect
//                                     width={200}
//                                     height={100}
//                                     fill="black"
//                                     opacity={0.3}
//                                     shadowEnabled={false}
//                                 />
//                                 {editable && <Circle 
//                                     participantId={participant._id}
//                                     onClick={onRemoveSignature}
//                                     signatureId={signature._id}
//                                     x={200}
//                                     fill="red"
//                                     radius={7}
//                                 />}
//                             </Group>
                            
//                         )
//                       })
//                     )}
//                   </Layer>
//                 </Stage>
//                 <div className="custom-pdf" style={{
//                     top: `-842px`,
//                     width: `595px`,
//                     marginBottom: `-842px`
//                 }}> 
//                 <Document
//                     file={url}
//                     onLoadSuccess={onDocumentLoadSuccess}
//                     style={{
//                         // width: '200px',
//                     }}
//                 >   
//                     <div>  
//                             <Page
//                                 className="my-3"
//                                 width={width}
//                                 pageNumber={currentPage}
//                             />
//                     </div>
//                 </Document>
//                 </div>
//               </div>
//     )
// }




export function PdfPlaceholder({ width = 600, height = 750 } = {}) {
    return (<div 
        className="pulse-animation d-flex justify-content-center align-items-center"
        style={{backgroundColor: 'rgb(224, 224, 224)', width, height }} 
    > 
      <TratoLoader className="rounded-circle" size="xl" />
    </div>)
}
const DEFAULT_WIDTH = 595;

function PdfPreview({ url, width: initialWidth = DEFAULT_WIDTH, onMouseUp, highlightSearch = '', pageNumber, initialPageNumber = 1, canvasRef, resetWidthOnUrlChange, clickPanels, controlsClassName, onPageChange = noop, onPageLoad = noop,  onDocumentLoad = noop, controls, children }) {
  const { t } = useTranslation();
  const [numPages, setNumPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [width, setWidth] = useState(initialWidth);

  console.log({url})

  const onPageLoadSuccess = useCallback((pageInfo) => {
    const rotation = pageInfo._pageInfo.rotate;
    const shouldInvertDimensions = [90, 270].includes(rotation);
    const [,,originalWidth, originalHeight] = pageInfo._pageInfo.view;
    const ratio = shouldInvertDimensions ? pageInfo.height/originalHeight : pageInfo.width/originalWidth

    onPageLoad({ 
      ...pageInfo,
      rotation,
      ratio: isNaN(ratio) ? 1 : ratio,
      width: shouldInvertDimensions ? pageInfo.height : pageInfo.width,
      height: shouldInvertDimensions ? pageInfo.width : pageInfo.height,
      areDimensionsInverted: shouldInvertDimensions,
      originalWidth: shouldInvertDimensions ? originalHeight : originalWidth,
      originalHeight: shouldInvertDimensions ? originalWidth : originalHeight
    })
  }, [onPageLoad]);

  const onDocumentLoadSuccess = useCallback(({numPages}) => {
    setNumPages(numPages);
    onDocumentLoad({ numPages })
  }, [onDocumentLoad]);

  const highlightPattern = useCallback((text, pattern) => {

    if (!pattern.length) {
      return text;
    }
  
    const textToTest = text.replace(/\s+/gi, ' ');
    const splitText = textToTest.toLowerCase().split(pattern.toLowerCase());

    if (splitText.length <= 1) {
      return textToTest;
    }
  
    const matches = textToTest.match(new RegExp(`${pattern}`, 'ig'));

    return splitText.reduce(
      (arr, element, index) =>
        matches?.[index]
          ? [...arr, element, <mark class="highlight">{matches[index]}</mark>]
          : [...arr, element],
      []
    );
  }, []);

  const makeTextRenderer = useCallback(
    (searchText) => (textItem) => highlightPattern(textItem.str, searchText)
  , [highlightPattern]);


  const handleNextPage = useCallback(() => {
      setCurrentPage(currentPage => {
        const newPage = Math.min(currentPage + 1, numPages)
        onPageChange(newPage)  
        return newPage;
      })
  }, [onPageChange, numPages])

  const handlePrevPage = useCallback(() => {
      setCurrentPage(currentPage => {
        const newPage = Math.max(currentPage - 1, 1)
        onPageChange(newPage)  
        return newPage;
      })
  }, [onPageChange])

  useEffect(() => {
      if (pageNumber) {
        setCurrentPage(pageNumber)
      }
  }, [pageNumber])

  useEffect(() => {
    setCurrentPage(initialPageNumber)
    if (resetWidthOnUrlChange) setWidth(0)
  }, [resetWidthOnUrlChange, url, initialPageNumber])

  useEffect(() => {
    setWidth(initialWidth)
  }, [initialWidth])

  return (
  <div className="d-flex flex-column h-100 ">
    <div className="d-flex flex-column h-100">
      <div className="h-100">  
        <div className="position-relative">
          { clickPanels && <>
            <ClickPanel top={0} left={0} onClick={handlePrevPage} />
            <ClickPanel top={0} right={0} onClick={handleNextPage} />
          </> }
          <Document
              file={url}
              onLoadSuccess={onDocumentLoadSuccess}
              options={options}
              className="page-box-shadow mb-3"
              loading={<PdfPlaceholder />}
          >
              {/* {Array.from(new Array(numPages), (el, index) => ( */}
            <Page
                // className="w-100"
                // key={`page_${index + 1}`}
                pageNumber={currentPage}
                onLoadSuccess={onPageLoadSuccess}
                width={width}
                customTextRenderer={makeTextRenderer(highlightSearch)}
                onMouseUp={onMouseUp}
                renderInteractiveForms={true}
                loading={<PdfPlaceholder />}
                canvasRef={canvasRef}
            >
              {children}
            </Page>
              {/* ))} */}
              {/* <Outline pdf={pdf}/> */}
          </Document>
        </div>
      </div>
      <div>
      {controls &&
        <Controls className={clsx("text-center", controlsClassName)} height={true || width < 500}>
          <ButtonGroup className="shadow rounded bg-white">
            <Button size="lg" color="default" disabled={currentPage === 1} onClick={handlePrevPage}><i className="fas fa-caret-left" /></Button>
            <div className="align-self-center">
            {numPages ?
              <span>{currentPage} {t('common.of')} {numPages}</span>
              :
              <Spinner size="sm"/>
            }
            </div>
            <Button size="lg" color="default" disabled={currentPage === numPages} onClick={handleNextPage}><i className="fas fa-caret-right" /></Button>
          </ButtonGroup>
        </Controls>
        }
      </div>
    </div>
  </div>)
}

export default PdfPreview;


